import { supabase } from '../lib/supabase.js';
import { $, busy } from '../lib/ui.js';

export function renderLogin(app) {
  app.innerHTML = `
    <form class="card center form" id="login">
      <h2>Sign in</h2>
      <input id="email" type="email" autocomplete="username" placeholder="Email" required>
      <input id="pw" type="password" autocomplete="current-password" placeholder="Password" required>
      <button class="primary big" type="submit">Sign in</button>
      <p class="hint" style="padding:0">No account? Ask the ACME admin to create one for you.</p>
    </form>`;
  $('#login').onsubmit = e => {
    e.preventDefault();
    busy(e.submitter, async () => {
      const { error } = await supabase.auth.signInWithPassword({ email: $('#email').value.trim(), password: $('#pw').value });
      if (error) throw new Error(error.message === 'Invalid login credentials' ? 'Wrong email or password.' : error.message);
    }).catch(() => {});
  };
}
